var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLetter = function SvgLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.172 32.632V2.257H30.41l9.474 9.096v21.279",
    stroke: "currentColor",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.15 24.949 3.67 2.837V54.74H2V27.786l4.011-2.92",
    stroke: "currentColor",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2 29.79 13.912 10.263h14.765l12.888-9.68M2.094 54.743 16.09 40.307l14.168-.25L44 54.408M29.733 2.51v9.18h9.818M13.874 17.95h18.27M13.976 29.455H28.83M13.976 23.62h10.586",
    stroke: "currentColor",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  })));
};
export default SvgLetter;